export default {
  HOME: { path: "/", id: "loginhome" },
  LOGIN: { path: "/login", id: "login" },
  SIGNUP: { path: "/signup", id: "signup" },
  PROJECTPAGE: { path: "/projets", id: "projets" },
  FORGET_PASSWORD: { path: "/forget-password", id: "forgetpassword" },
  FORGET_PASSWORD_VERIFY_OTP: { path: "/verify-otp", id: "forgetpasswordotp" },
  RESET_PASSWORD: { path: "/reset-password", id: "resetpassword" },
  ADD_NEW_PROJECT: { path: "/add-new-project", id: "addnewproject" },
  UPDATE_PROJECT: { path: "/update-project", id: "updateproject" },
  PROJECT_UNIT_LIST: { path: "/project-unit/", id: "projectunitlist" },
  DEFAULT: { path: "*", id: "default" },
  PROJECT_UNIT_CREATE: { path: "/create-project-unit/", id: "createprojectunit" },
  PROJECT_UNIT_UPDATE: { path: "/update-project-unit", id: "updateprojectunit" },
  BOOKING: { path: "/bookings", id: "booking" },
  BOOKING_CREATE: { path: "/create-booking", id: "createbooking" },
  BOOKING_UPDATE: { path: "/update-booking", id: "updatebooking" },
  RECEIPT: { path: "/receipts", id: "receipt" },
  RECEIPT_CREATE: { path: "/create-receipt", id: "createreceipt" },
  RECEIPT_UPDATE: { path: "/update-receipt/", id: "updatereceipt" },
  EXPENSE: { path: "/expenses", id: "expense" },
  EXPENSE_CREATE: { path: "/create-expense", id: "createexpense" },
  EXPENSE_UPDATE: { path: "/update-expense/", id: "updateexpense" },
  USERS: { path: "/users", id: "users" },
  MARK_UNIT: { path: "/mark-unit/", id: "markunit" },
  PROJECT_STATUS_VIEW: { path: "/project-status-view/", id: "projectstatusview" },
  DASHBOARD: { path: "/dashboard", id: "dashboard" },
  CUSTOMER: { path: "/customers", id: "customer" },
  AGENTS: { path: "/agents", id: "agents" },
  DUE_REPORT: { path: "/due-report", id: "duereport" },
  PENDING_REGISTRATION_UNITS: { path: "/pending-registration-units", id: "pendingregistrationunits" },
  ADD_EXPENSE_TYPE: { path: "/expense-type", id: "addexpensetype" },
  ROLE: { path: "/roles", id: "role" },
  EXPENSES_REPORT: { path: "/expenses-report", id: "expensesreport" },
  MANAGE_TOWER: { path: "/manage-tower/", id: "managetower" },
  TOWER_STATUS_VIEW: { path: "/tower-status-view/", id: "towerstatusview" },
  FLOOR_STATUS_VIEW: { path: "/floor-status-view/", id: "floorstatusview" },
  SUMMARY_REPORT: { path: "/summary-report", id: "summaryreport" },
  CUSTOMER_VOUCHER: { path: "/customer-vouchers/", id: "customervoucher" },
  CUSTOMER_VOUCHER_CREATE: { path: "/create-customer-voucher", id: "createcustomervoucher" },
  CUSTOMER_VOUCHER_UPDATE: { path: "/update-customer-voucher/", id: "updatecustomervoucher" },
  COMPLETED_REGISTRATION_UNITS: { path: "/completed-registration-units", id: "completedregistrationunits" },
  BOOKED_UNITS: { path: "/booked-units", id: "bookedunits" },
  SUPPLIERS: { path: "/suppliers", id: "suppliers" },
  UNITS: { path: "/units", id: "units" },
  STOCKS: { path: "/stocks", id: "stocks" },
  INVENTORY: { path: "/inventory", id: "inventory" },
  ROYALTY: { path: "/royalty", id: "royalty" },
  AGENT_COMMISSION_REPORT: { path: "/agent-commission-report", id: "agentcommissionreport" },
  LOAN: { path: "/loan", id: "loan" },
  DAY_BOOK: { path: "/day-book", id: "daybook" },
};
